import { SectionHeader } from "@src/components/general/SectionHeader";
import {
  Flexbox,
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/components/layout/Flexbox";
import { useEncounterId } from "@src/features/encounters/state/encounterActor";
import { FileText, Receipt, Sparkles } from "lucide-react";
import { CodingCard } from "./CodingCard";
import { useMedicalCodes } from "./useMedicalCodes";

export const Coding = () => {
  const encounterId = useEncounterId();
  const { data, isLoading, isError } = useMedicalCodes(
    encounterId ?? undefined,
  );

  const icd10 = data?.data.icd10;
  const cpt = data?.data.cpt;

  return (
    <VerticalFlexbox gap="sm">
      <HorizontalFlexbox
        alignItems="center"
        justifyContent="space-between"
        gap="xs"
      >
        <SectionHeader>CODING</SectionHeader>
      </HorizontalFlexbox>
      <Flexbox gap="sm" className="flex-col md:flex-row">
        <CodingCard
          icon={FileText}
          title="Diagnosis Codes (ICD-10)"
          rows={icd10 ?? []}
          isLoading={isLoading}
          isError={isError}
        />
        <CodingCard
          icon={Receipt}
          title="Procedure Codes (CPT)"
          rows={cpt ?? []}
          isLoading={isLoading}
          isError={isError}
        />
        {/* Q&VB has no backing endpoint yet; renders the static placeholder. */}
        <CodingCard icon={Sparkles} title="Quality & Value-Based" />
      </Flexbox>
    </VerticalFlexbox>
  );
};
